/**
 * API Token Service
 * สำหรับเรียก API ที่เกี่ยวกับ API Token Management
 */

import api from '../utils/api'; // หรือ path ที่ถูกต้องของ axios instance
import { getAuthToken } from '../utils/auth'

// Add auth token ในทุก request
api.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * สร้าง API token ใหม่
 * @param {string} appName - ชื่อแอปพลิเคชัน
 * @returns {Promise} Response data
 */
export const createApiToken = async (appName) => {
  try {
    const response = await api.post('/api/api-tokens', {
      app_name: appName
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * ดึงรายการ API tokens
 * @param {string} status - Filter by status: 'active', 'inactive', 'all'
 * @returns {Promise} Response data
 */
export const getApiTokens = async (status = 'all') => {
  try {
    const response = await api.get('/api/api-tokens', {
      params: { status }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * ดึงข้อมูล API token เดี่ยว
 * @param {number} tokenId - Token ID
 * @returns {Promise} Response data
 */
export const getApiToken = async (tokenId) => {
  try {
    const response = await api.get(`/api/api-tokens/${tokenId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Regenerate API token
 * @param {number} tokenId - Token ID
 * @returns {Promise} Response data
 */
export const regenerateApiToken = async (tokenId) => {
  try {
    const response = await api.post(`/api/api-tokens/${tokenId}/regenerate`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Revoke/Delete API token
 * @param {number} tokenId - Token ID
 * @returns {Promise} Response data
 */
export const deleteApiToken = async (tokenId) => {
  try {
    const response = await api.delete(`/api/api-tokens/${tokenId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * ดึง request logs ของ API token
 * @param {number} tokenId - Token ID
 * @param {object} options - Filter options (method, status, limit, offset)
 * @returns {Promise} Response data
 */
export const getApiTokenLogs = async (tokenId, options = {}) => {
  try {
    const response = await api.get(`/api/api-tokens/${tokenId}/logs`, {
      params: options
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * ดึง log เดี่ยว (รวม request/response body)
 * @param {number} tokenId - Token ID
 * @param {number} logId - Log ID
 * @returns {Promise} Response data
 */
export const getApiTokenLog = async (tokenId, logId) => {
  try {
    const response = await api.get(`/api/api-tokens/${tokenId}/logs/${logId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};


export default {
  createApiToken,
  getApiTokens,
  getApiToken,
  regenerateApiToken,
  deleteApiToken,
  getApiTokenLogs,
  getApiTokenLog
};